import React from "react";

export default function SearchIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.0194 11.0782L14.8747 13.9328L13.9314 14.8762L11.0767 12.0208C10.0145 12.8723 8.69337 13.3354 7.33203 13.3335C4.02003 13.3335 1.33203 10.6455 1.33203 7.3335C1.33203 4.0215 4.02003 1.3335 7.33203 1.3335C10.644 1.3335 13.332 4.0215 13.332 7.3335C13.334 8.69483 12.8708 10.016 12.0194 11.0782ZM10.682 10.5835C11.5281 9.71342 12.0006 8.54712 11.9987 7.3335C11.9987 4.75483 9.91003 2.66683 7.33203 2.66683C4.75336 2.66683 2.66536 4.75483 2.66536 7.3335C2.66536 9.9115 4.75336 12.0002 7.33203 12.0002C8.54565 12.0021 9.71196 11.5296 10.582 10.6835L10.682 10.5835Z"
        fill={props.fill || "#0D1126"}
        fillOpacity={props.fillOpacity || 0.6}
      />
    </svg>
  );
}
